
import temperaturas from "../../img/remolque/temperaturas.jpeg";
import horasMotor from "../../img/remolque/horasMotor.jpeg";
import medidorVacio from "../../img/remolque/medidorVacio.jpeg";
import bombaEnCeros from "../../img/remolque/bombaEnCeros.jpeg";
import medidorLleno from "../../img/remolque//medidorLleno.jpeg";
import bombaConGalones from "../../img/remolque/bombaConGalores.jpeg";
import bombaLovesGalones from "../../img/remolque/bombaLovesLleno.png";



// PASOS DEL FLUJO DE DESCARGA DE DIESEL REMOLQUE
export const stepRemolqueDescarga = [
        
    {
        id: 13,
        numPaso: 1,
        title: "Foto de la temperatura del Reefer",
        description:
            "Toma una foto de la temperatura del reefer para documentar su lectura actual.",
        photoRequired: true,
        inputs: [
            { label: "Temperatura del reefer", key: "reeferTemperature", type: "temperature" },
        ],
        photoExample: temperaturas,
    },
    {
        id: 14,
        numPaso: 2,
        title: "Foto de las horas del Reefer",
        description:
            "Toma una foto del indicador de horas del reefer para documentar su lectura actual.",
        photoRequired: true,
        inputs: [
            { label: "Horas del reefer", key: "reeferHours", type: "numberFormat" },
        ],
        photoExample: horasMotor,
    },
    {
        id: 15,
        numPaso: 3,
        title: "Foto y Nivel del Tanque de Combustible del Reefer",
        description:
            "Tome una foto del nivel del tanque de combustible del reefer para documentar su lectura actual.",
        photoRequired: true,
        inputs: [
            { label: "Nivel del tanque de combustible del reefer", key: "reeferTankLevel", type: "range" },
        ],
        photoExample: medidorVacio,
    },
    {
        id: 16,
        numPaso: 4,
        title: "Selecciona el tipo de operación y escriba el número de orden",
        description:
            "Selecciona el tipo de operación y escribe el número de orden.",
        inputs: [
            {
                label: "Tipo de operación",
                key: "operationType",
                type: "autocomplete",
                options: ["Importación", "Exportación"],
            },
        ],
    },
    {
        id: 99,
        numPaso: 5,
        title: "Finalización del Proceso",
        description: "Haz clic en el botón para finalizar el proceso.",
        photoRequired: false,
        final: true,
    },
];

export const stepsFullQuestionsRemolque = [
    {
        id: 13,
        numPaso: 1,
        title: "Foto de la temperatura del Reefer",
        description:
            "Toma una foto de la temperatura del reefer para documentar su lectura actual.",
        photoRequired: true,
        inputs: [
            { label: "Temperatura del reefer", key: "reeferTemperature", type: "temperature" },
        ],
        photoExample: temperaturas,
    },
    {
        id: 14,
        numPaso: 2,
        title: "Foto de las horas del Reefer",
        description:
            "Toma una foto del indicador de horas del reefer para documentar su lectura actual.",
        photoRequired: true,
        inputs: [
            { label: "Horas del reefer", key: "reeferHours", type: "numberFormat" },
        ],
        photoExample: horasMotor,
    },
    {
        id: 15,
        numPaso: 3,
        title: "Foto y Nivel del Tanque de Combustible del Reefer",
        description:
            "Tome una foto del nivel del tanque de combustible del reefer para documentar su lectura actual.",
        photoRequired: true,
        inputs: [
            { label: "Nivel del tanque de combustible del reefer", key: "reeferTankLevel", type: "range" },
        ],
        photoExample: medidorVacio,
    },
    {
        id: 16,
        numPaso: 4,
        title: "Selecciona el tipo de operación y escriba el número de orden",
        description:
            "Selecciona el tipo de operación y escribe el número de orden.",
        inputs: [
            {
                label: "Tipo de operación",
                key: "operationType",
                type: "autocomplete",
                options: ["Importación", "Exportación"],
            },
        ],
    },
    {
        id: 17,
        numPaso: 1,
        title: "Foto del odómetro de la bomba de combustible en cero",
        description:
            "Antes de cargar combustible, asegúrate de que el odómetro de la bomba esté en cero y toma una foto para confirmarlo.",
        photoRequired: true,
        inputs: [
            { label: "Odómetro de la bomba", key: "odometerBomb", type: "numberFormat" },
        ],
        photoExample: bombaEnCeros,
    },
    {
        id: 18,
        numPaso: 2,
        title: "Llena el tanque y toma una Foto del indicador del Tanque para Mostrar que Está Lleno",
        description:
            "Toma una foto del nivel del líquido para confirmar que está completamente lleno.",
        photoRequired: true,
        photoExample: medidorLleno,
    },
    {
        id: 20,
        numPaso: 3,
        title: "Foto de la Bomba de Combustible con los Galones Cargados y el Odómetro",
        description:
            "Después de cargar combustible, toma una foto de la bomba mostrando el total de galones cargados y la lectura del odómetro.",
        photoRequired: true,
        inputs: [
            { label: "Galones cargados", key: "fuelLoaded", type: "numberFormat" },
            { label: "Odómetro de la bomba", key: "odometerFinal", type: "numberFormat" },
        ],
        photoExample: bombaConGalones,
    },
    {
        id: 99,
        numPaso: 5,
        title: "Finalización del Proceso",
        description: "Haz clic en el botón para finalizar el proceso.",
        photoRequired: false,
        final: true,
    },
];

// PASOS DEL FLUJO DE CARGA DE DIESEL EN COLOMBIA
export const stepCajasCargarColombia = [
    
    {
        id: 17,
        numPaso: 1,
        title: "Foto del odómetro de la bomba de combustible en cero",
        description:
            "Antes de cargar combustible, asegúrate de que el odómetro de la bomba esté en cero y toma una foto para confirmarlo.",
        photoRequired: true,
        inputs: [
            { label: "Odómetro de la bomba", key: "odometerBomb", type: "numberFormat" },
        ],
        photoExample: bombaEnCeros,
    },
    {
        id: 18,
        numPaso: 2,
        title: "Llena el tanque y toma una Foto del indicador del Tanque para Mostrar que Está Lleno",
        description:
            "Toma una foto del nivel del líquido para confirmar que está completamente lleno.",
        photoRequired: true,
        photoExample: medidorLleno,
    },
    {
        id: 20,
        numPaso: 3,
        title: "Foto de la Bomba de Combustible con los Galones Cargados y el Odómetro",
        description:
            "Después de cargar combustible, toma una foto de la bomba mostrando el total de galones cargados y la lectura del odómetro.",
        photoRequired: true,
        inputs: [
            { label: "Galones cargados", key: "fuelLoaded", type: "numberFormat" },
            { label: "Odómetro de la bomba", key: "odometerFinal", type: "numberFormat" },
        ],
        photoExample: bombaConGalones,
    },
    {
        id: 99,
        numPaso: 4,
        title: "Finalización del Proceso",
        description: "Haz clic en el botón para finalizar el proceso.",
        photoRequired: false,
        final: true,
    },
];

// PASOS DEL FLUJO DE CARGA DE DIESEL EN LAREDO,TX (TOWER)
export const stepCajasCargarTower = [
    {
        id: 9,
        numPaso: 1,
        title: "Llenar el tanque a capacidad y toma una Foto del indicador del Tanque para Mostrar que Está Lleno.",
        description: "Llena el tanque del reefer a su capacidad máxima.",
        photoRequired: true,
        photoExample: medidorLleno,
    },
    {
        id: 99,
        numPaso: 2,
        title: "Finalización del Proceso",
        description: "Haz clic en el botón para finalizar el proceso.",
        photoRequired: false,
        final: true,
    },
];

// PASOS DEL FLUJO DE CARGA DE DIESEL EN LAREDO,TX (LOVE'S)
export const stepCajasCargarLoves = [
    {
        id: 9,
        numPaso: 1,
        title: "Llenar el tanque a capacidad y toma una Foto del indicador del Tanque para Mostrar que Está Lleno.",
        description: "Llena el tanque del reefer a su capacidad máxima.",
        photoRequired: true,
        photoExample: medidorLleno,
    },
    {
        id: 9,
        numPaso: 2,
        title: "Tomar una foto al medidor de la bomba con los galones cargados",
        description:
            "Después de cargar combustible, ingresa manualmente la cantidad de galones cargados y luego toma una foto que muestre claramente ese valor",
        photoRequired: true,
        inputs: [
            { label: "Galones cargados", key: "fuelLoaded", type: "numberFormat" },
        ],
        signatureRequired: false,
        photoExample: bombaLovesGalones,
    },
    {
        id: 99,
        numPasos: 3,
        title: "Finalización del Proceso",
        description: "Haz clic en el botón para finalizar el proceso.",
        photoRequired: false,
        final: true,
    },
];